import styled from 'styled-components/macro';

// STYLING:
const redClr = '#FF5F5F';

export const StyledValidationError = styled.p.attrs({ role: 'alert' })`
    color: ${redClr};
    margin-top: 0.8rem;
`;
